import { useState } from "react";
import { TopBar } from "@/components/layout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Eye } from "lucide-react";
import { useMapVisualData } from "@/hooks/useMapVisualData";
import { MapVisualDashboard } from "@/components/map-visual/MapVisualDashboard";

const MapVisualPage = () => {
  const [selectedMapId, setSelectedMapId] = useState<string | null>(null);
  const { maps, seeds, nodes, loading } = useMapVisualData(selectedMapId);

  const selectedMap = maps.find(m => m.id === selectedMapId);

  return (
    <>
      <TopBar title="Mapa Wizualna" />
      <div className="flex-1 overflow-auto p-6">
       <div className="mx-auto w-full max-w-[1600px]">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg font-semibold flex items-center gap-2">
              <Eye className="h-5 w-5 text-violet-400" />
              Wizualizacja Topical Map
            </h2>
            <p className="text-sm text-muted-foreground">
              Sunburst, Force Graph i Status Grid — interaktywny podglad struktury mapy
            </p>
          </div>
          <div className="w-[300px]">
            <Select value={selectedMapId || ""} onValueChange={(v) => setSelectedMapId(v)}>
              <SelectTrigger>
                <SelectValue placeholder="Wybierz mape..." />
              </SelectTrigger>
              <SelectContent>
                {maps.map(m => (
                  <SelectItem key={m.id} value={m.id}>
                    {m.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        {loading && (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          </div>
        )}

        {!loading && !selectedMapId && (
          <div className="border-2 border-dashed rounded-xl p-16 text-center">
            <Eye className="h-12 w-12 mx-auto mb-3 text-muted-foreground/30" />
            <p className="text-lg font-medium text-muted-foreground">Wybierz mape z listy</p>
            <p className="text-sm text-muted-foreground mt-1">
              Wizualizacja pojawi sie po wybraniu mapy tematycznej
            </p>
          </div>
        )}

        {!loading && selectedMapId && selectedMap && (
          <MapVisualDashboard
            mapName={selectedMap.name}
            seeds={seeds}
            nodes={nodes}
          />
        )}
       </div>
      </div>
    </>
  );
};

export default MapVisualPage;
